module.exports = __webpack_public_path__ + "assets/CloseBtn.36440b7d2e7981d6a80c765efc3eb302.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/levels/CloseBtn.svg
// module id = 59
// module chunks = 0